import axios from '@/plugins/axios'
import { Message } from "element-ui";

export default {
  namespaced: true,

  state: {
    loading: false,
    challenges: {},
    music_challenges: [],
    wallet:0,
    budget:0,
    page: 1,
    page_size: 10,
    total: 0,
    page_count: 0,
    order_column: 'id',
    order_type: 'desc',
    dialog: false,
    music_challenge: '',
    challenge: {
      id: null,
     /* username: '',
      link: null,
      count: null,*/
      wallet: 0,
     /* paypal: null,
      position: 1,*/
    },
    user_types: []
  },

  mutations: {
    removeLastBonus(state, submissionId) {
      const submission = state.challenges.data.findIndex(_ => _.id === submissionId)
      if (submission !== -1) state.challenges.data[submission].bonuses.pop()
    },
    setChallenges(state, payload) {
      state.challenges = payload
    },
    setMusicChallenges(state, payload) {
      state.music_challenges = payload

    },
    setWallet(state, payload) {
      state.wallet = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setTotal(state, payload) {
      state.total = payload
    },
    setPageCount(state, payload) {
      state.page_count = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedChallenge(state, payload) {
      state.music_challenge = payload
    },
    setSelectedTrack(state, payload) {
      state.challenge = payload
    },
    setBudget(state, payload) {
      state.budget = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    reset(state) {
      state.challenges = {}
      state.music_challenges = []
      state.wallet = 0
      state.budget = 0
      state.page = 1
      state.page_size = 10
      state.dialog = false
      state.music_challenge = ''
      state.challenge = {
        id: null,
        wallet: 0,
      }
    },
  },

  actions: {
    readChallenges({ commit},type) {
      axios.admin.get('/instagram-challenge/challenges',
        {
          params:{
            challenge_type:type
          }
        }).then(r => {
        commit('setMusicChallenges', r.data)
      })
    },
    read({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('/instagram-challenge/submissions', {
          params: {
            challenge_id: state.music_challenge,
            page: state.page,
            perPage: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setChallenges', r.data.data)
          commit('setWallet', r.data.data.sum)
          commit('setTotal', r.data.meta.total)
          commit('setPageCount', r.data.meta.last_page)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, data) {
      axios.admin
        .put('/instagram-challenge/edit/' + data.id, {
          bonuses: data.bonuses,
        })
        .then(() => {
          commit('setDialog', false)
          Message({ message: 'You have successfully added bonus', type: 'success' })
        })
        .catch(() => {
          commit('removeLastBonus', data.id)
        })
    },
    delete({ dispatch }, id) {
      axios.admin.delete('instagram-challenge/delete/' + id).then(() => {
        dispatch('read')
      })
    },
  },

  getters: {
    getChallenges(state) {
      return state.music_challenge
    }
  }
}
